var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSelectionPolygon = function SvgSelectionPolygon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0,14.93v-2.13h1.02v1.07h1.02v1.07H0ZM6.45,6.03l.58.88-.96.74-2.39-1.39.47-.95,1.82,1.08.48-.37Zm3.05-1.08l-.61-.85,1.43-1.06.61.85-1.43,1.06ZM1.02,6.4v-1.47l.48.27.51-.93L0,3.2v3.2h1.02Zm11.83-3.92l.45-.35h1.02V0l-2.09,1.61.62.87ZM1.02,10.67H0v-2.13h1.02v2.13Zm3.07,4.27v-1.07h2.05v1.07h-2.05ZM14.33,6.4h-1.02v-2.13h1.02v2.13Zm1.67,5.16l-6.79-5.16v8.73l1.77-2.53,1.65,3.4,2.09-1.09-1.61-3.34h2.89Zm-2.07,2.96l-1.12.65-1.77-3.69-1.14,1.75-.04-5.47,4.27,3.18-1.96-.02,1.75,3.61Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelectionPolygon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selection-polygon.6d2ddf95.svg";
export { ForwardRef as ReactComponent };